import { UtilityBillByIdDTO } from "api";
import { UtilityBillFormData } from "types";
import { QUERY_KEYS } from "consts";
import { useNotify } from "hooks";
import { extractErrorMessage } from "utils";

interface UseStatusHandlersParams {
  utilityBill?: UtilityBillByIdDTO;
  watchValues: UtilityBillFormData;
  queryClient: ReturnType<typeof import("@tanstack/react-query").useQueryClient>;
  notify: ReturnType<typeof useNotify>;
  updateBillStatus: (payload: { id: string; status: string }, options?: any) => Promise<any>;
  setButtonName: (name: string) => void;
}

export const useStatusHandlers = ({
  utilityBill,
  watchValues,
  queryClient,
  notify,
  updateBillStatus,
  setButtonName,
}: UseStatusHandlersParams) => {
  const handleSetStatus = (status: string) => {
    if (!utilityBill) {
      notify.error("Utility bill not found");
      return;
    }

    const statusChangePayload = {
      id: utilityBill.id,
      status
    };

    if (status === "Not Applicable (Cost Only)") {
      if ((!watchValues?.startDate?.isValid() || !watchValues?.endDate?.isValid())
        || watchValues?.collector === "- / - / -"
        || (watchValues?.amount === undefined || watchValues?.amount === null || watchValues?.amount === "")
      ) {
        notify.error("Please fill in the required fields before setting the status to 'Not Applicable (Cost Only)'");
      } else {
        updateBillStatus(statusChangePayload, {
          onSuccess: () => {
            queryClient.invalidateQueries([QUERY_KEYS.UTILITY_BILLS, utilityBill.id]);
            notify.success(`Status successfully changed to ${status}`);
          },
          onError: (error: unknown) => {
            notify.error(extractErrorMessage(error, "Failed to update status"));
          }
        });
      }
    }

    if (status === "Not Applicable (Invalid Data)") {
      updateBillStatus(statusChangePayload, {
        onSuccess: () => {
          queryClient.invalidateQueries([QUERY_KEYS.UTILITY_BILLS, utilityBill.id]);
          notify.success(`Status successfully changed to ${status}`);
        },
        onError: (error: unknown) => {
          notify.error(extractErrorMessage(error, "Failed to update status"));
        }
      });
    }

    setButtonName("");
  };

  return {
    handleSetStatus,
  };
};

